<style lang="less" scoped>
@import '../../../style/common/variable';
ul,li {margin: 0;padding: 0;list-style: none;}
.rcep{width: 1200px;margin: 10px auto;display: flex;flex-direction: column;background: #fff;position: relative;background: #f2f2f2;}
.center {width: 1200px;margin: auto;display: flex;justify-content: space-between;}
.navigation {margin-left: 10px !important;}
.gov-site-left {width: 280px;height: 256px;}
.gov-leader {border: 1px solid #e5e8ea;box-sizing: border-box;}
.leader-title {background: #035294;font-size: 18px;color: #fff;height: 50px;line-height: 50px;margin: 0;}
.more-child-list {width: 280px;text-align: left;}
.more-child-list-li {border-bottom: 1px dotted #ccc;font-size: 16px;line-height: 45px;padding-left: 65px;display: flex;}
.more-child-list-li-img {width: 16px;height: 16px;margin-top: 15px}
.more-child-list-li-span {margin-left: 10px;cursor: pointer;}
.gov-site-right {width: 900px;}
.second-gird {margin-bottom: 40px;}
.more-chlid-title {border-bottom: 1px solid #025193;height: 40px;line-height: 40px;overflow: hidden;margin-bottom: 10px;display: flex;justify-content: space-between;}
.more-chlid-title strong {background: #025193;color: #fff;cursor: pointer;padding: 0 30px;font-size: 16px;font-weight: normal;}
.more-chlid-title span {color: #434242;font-size: 14px;cursor: pointer;}
.txt-list li {display: flex;justify-content: space-between;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;line-height: 40px;padding-left: 15px;background: url(../../../../static/images/zlkindex/dian2.png) 0 14px no-repeat;}
@media screen and (max-width: @max-screen){
  .gov-site-left{display: none;}
}
</style>

<template>
  <div class="rcep">
    <Navigation v-if="this.isMobile()" :navigationdatas="navigationListApp" class="navigation"></Navigation>
    <Navigation v-else :navigationdatas="navigationList" class="navigation"></Navigation>
    <div class="center">
      <div class="gov-site-left">
        <div class="gov-leader">
          <h2 class="leader-title">RCEP业务专栏</h2>
          <ul class="more-child-list">
            <li class="more-child-list-li" v-for="(item, index) in catiddata" :key="index"><img src="../../../../static/images/zlkindex/right.png" alt="" class="more-child-list-li-img"><span class="more-child-list-li-span" @click="goList(item)">{{ item.dispc }}</span></li>
          </ul>
        </div>
      </div>
      <RcepList :catiddata="catiddata" :widthCSH="widthCSH"></RcepList>
    </div>
  </div>
</template>

<script>
import Navigation from '../assembly/Navigation.vue'
import RcepList from '../assembly/RcepList.vue'
export default {
  components: {
    Navigation,
    RcepList
  },
  name: '',
  data()
  {
    return {
      navigationList: [
        {theme: '首页', path: '/Kyforum'},
        {theme: 'RCEP业务专栏', path: ''}
      ],
      navigationListApp: [
        {theme: '首页', path: '/KyforumApp'},
        {theme: 'RCEP业务专栏', path: ''}
      ],
      catiddata: [],
      widthCSH: 900
    }
  },
  created()
  {
    this.getRcepCatid()
  },
  methods: {
    goList(item)
    {
      let url = this.$router.resolve({path: '/RcepLB', query: {catid: item.id}})
      window.open(url.href, '_blank')
    },
    getRcepCatid()
    {
      // 获取分类
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: `moduleid=41`}
      window.post.getPost(paras).then((ret) =>
      {
        this.catiddata = []
        let temp = []
        ret.forEach(item =>
        {
          temp.push({id: item.id, dispc: item.dispc, children: []})
        })
        // 获取对应分类的数据
        let paras1 = {cmd: 'query', _major: 11, _minor: 107, _exp: `id>0`, orderby: 'addtime Desc'}
        window.post.getPost(paras1).then((ret1) =>
        {
          ret1.forEach((item1, index1) =>
          {
            temp.forEach((item2, index2) =>
            {
              if (item1.catid === item2.id)
              {
                item2.children.push(
                  {
                    addtime: item1.addtime,
                    author: item1.author,
                    catid: item1.catid,
                    copyfrom: item1.copyfrom,
                    edittime: item1.edittime,
                    hits: item1.hits,
                    id: item1.id,
                    title: item1.title
                  }
                )
              }
            })
          })
          this.catiddata = temp
        })
      })
    },
    // 用户设备的判断
    isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Rcep.vue